// import React from "react";
// import { AiOutlineArrowRight } from "react-icons/ai";

// const WhyChoose = () => {
//   const services = [
//     {
//       icon: "https://img.freepik.com/free-vector/global-stock-market-concept-illustration_114360-19030.jpg?uid=R90634854&ga=GA1.1.1673403856.1719407260&semt=ais_hybrid",
//       title: "✅ Beginner-Friendly",
//       description: "Simple tools and guides to help you start.",
//     },
//     {
//       icon: "https://img.freepik.com/free-photo/top-view-finger-pressing-percentage-tablet_1134-278.jpg?uid=R90634854&ga=GA1.1.1673403856.1719407260&semt=ais_hybrid",
//       title: "✅ Real-Time Insights",
//       description: "Stay ahead with live market updates.",
//     },
//     {
//       icon: "https://img.freepik.com/free-vector/income-graph-is-rising_530521-1785.jpg?uid=R90634854&ga=GA1.1.1673403856.1719407260&semt=ais_hybrid",
//       title: "✅ Low Fees, High Profits",
//       description: "Trade more, keep more of your earnings.",
//     },
//     {
//       icon: "https://img.freepik.com/free-vector/call-center-design_24877-49645.jpg?uid=R90634854&ga=GA1.1.1673403856.1719407260&semt=ais_hybrid",
//       title: "✅ 24/7 Support",
//       description: " Our team is always here to help you.",
//     },
//   ];

//   return (
//     <div className="px-4 pt-6 pb-8 mx-auto max-w-7xl sm:pt-16 sm:px-2">
//       {/* Header */}
//       <div className="mb-8">
//         <span className="block mb-1 text-sm font-medium text-indigo-500">Why Choose Us?</span>
//         <div className="items-center justify-between block sm:flex">
//           <h2 className="text-3xl font-semibold">
//             <span className="text-yellow-400"> Your Trusted Partner in  </span> Trading Success
//             <p className="max-w-2xl mx-auto text-lg font-normal text-gray-600">
//             We make trading easy, safe, and profitable for everyone.
//           </p>
//           </h2>
//           <button className="flex items-center gap-2 p-1 py-1 mt-3 text-white bg-yellow-400 rounded-full sm:mt-0">
//            <span className="px-4 py-2 bg-green-800 rounded-full"> View All Services</span>
//             <div className="p-3 bg-white rounded-full">
//               <AiOutlineArrowRight className="w-4 h-4 text-green-600" />
//             </div>
//           </button>
//         </div>
//       </div>

//       {/* Services Grid */}
//       <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//         {services.map((service, index) => (
//           <div key={index} className="p-6 transition-shadow bg-white border border-gray-300 rounded-lg hover:shadow-lg">
//             <img src={service.icon} alt={service.title} className="w-8 h-8 mb-4" />
//             <h3 className="mb-2 text-lg font-medium text-gray-800">{service.title}</h3>
//             <p className="mb-4 text-sm text-gray-500">{service.description}</p>
//             <button className="flex items-center text-sm text-gray-600 hover:text-gray-800">
//               Learn more
//               <AiOutlineArrowRight className="w-4 h-4 ml-1" />
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default WhyChoose;

import React from "react";
import { FaAward, FaHeart, FaClock, FaUsers } from "react-icons/fa";

const WhyChooseUsSection = () => {
  const cards = [
    {
      icon: <FaAward className="w-10 h-10 text-blue-600" />,
      title: "Faster Execution",
      description:
        "Make trades instantly with AI-driven speed.",
        bgColor: "bg-blue-600",
        textColor: "group-hover:text-blue-600"
    },
    {
      icon: <FaHeart className="w-10 h-10 text-red-600" />,
      title: "Risk Management ",
      description:
        "Smart tools to help minimize losses.",
         bgColor: "bg-red-600",
        textColor: "group-hover:text-red-600"
    },
    {
      icon: <FaClock className="w-10 h-10 text-green-600" />,
      title: "Flexible Trading Options",
      description:
        "Choose manual or automated strategies.",
         bgColor: "bg-green-600",
        textColor: "group-hover:text-green-600"
    },
    {
      icon: <FaUsers className="w-10 h-10 text-yellow-600" />,
      title: " Global Market Access ",
      description: "Trade anytime, anywhere with ease.",
       bgColor: "bg-yellow-600",
        textColor: "group-hover:text-yellow-600"
    },
  ];

  return (
    <div className="py-20 bg-gradient-to-b from-blue-200 via-white to-blue-50">
      <div className="container mx-auto px-6 text-center">
        {/* Section Header */}
        <h2 className="text-4xl font-semibold text-gray-900 mb-2 drop-shadow-md">
        Why Choose Teirrax
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-12">
        We combine AI technology, automation, and security to give you a seamless trading experience.
        </p>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="group relative bg-white/40  shadow-sm border border-gray-300 rounded-sm overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-lg hover:bg-white/80"
            >
              {/* Card Content */}
              <div className="p-4 text-center">
                <div className="flex justify-center mb-4">{card.icon}</div>
                <h3 className={` mt-4 font-semibold leading-5 text-gray-900 mb-2 ${card.textColor} transition duration-300 `}>
                  {card.title}
                </h3>
                <p className=" text-sm  text-gray-900 group-hover:text-gray-900 transition duration-300">
                  {card.description}
                </p>
              </div>

              {/* Bottom Line Animation */}
              <div className={`absolute bottom-0 left-0 h-1 ${card.bgColor} w-0 transition-all duration-500 group-hover:w-full`}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsSection;
